import strings from 'utils/strings'
import {
  DASH_LABELS,
  DASH_TYPES,
  DIGITAL_DASH_CODE,
  DIGITAL_ICU_LEFT_FILE_NAME,
} from './dashConstants'

export const META_BY_LOCATION_DETAIL = {
  F: {
    dependency: {
      panelNumber: 'A66-01975-000',
      top: 9,
      left: 10,
      width: 69,
      height: 117,
      zIndex: 5,
    },
  },
  Y: {
    dependency: {
      panelNumber: 'A66-01975-000',
      top: 9,
      left: 10,
      width: 69,
      height: 117,
      zIndex: 5,
    },
  },
  SSMSF: {
    partOverride: 'A06-90732-000',
  },
  C: {
    partOverride: 'CAS216806',
  },
  MST: {
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  MSF: {
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  LSMST: {
    partOverride: 'A06-90731-000',
  },
  ICU: {
    label: DASH_LABELS.A_PANEL_ICU,
    partOverride: '43N_ICU',
    noTooltip: true,
    disableEvents: true,
    partExpected: true,
    noShowPartNumber: true,
    [DIGITAL_DASH_CODE]: DIGITAL_ICU_LEFT_FILE_NAME,
  },
  ICUC5: {
    label: DASH_LABELS.A_PANEL_ICU,
    partOverride: DIGITAL_ICU_LEFT_FILE_NAME,
    noTooltip: true,
    disableEvents: true,
    partExpected: true,
    noShowPartNumber: true,
  },
  AUPNL: {
    partOverride: 'A22-74137-001',
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AUX,
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
    containedIn: 'AGFAC',
  },
  AUDSP: {
    partOverride: '000 446',
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AUX,
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
  },
  AGFAC: {
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AG,
    partOverride: 'A22-73784',
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
  },
}

export const DASH_META = {
  name: DASH_TYPES.DASH_38N_E_VAULT,
  panels: ['ICU', 'AGFAC'],
  navPanels: ['AUPNL'],
  navOrder: ['ICU', 'AUPNL', 'AGFAC'],
  // PBI 479416: fit the API's full-width ICU (1360px) beside AGFAC (2578px).
  width: 4200,
  height: 1336,
}

export const FALLBACK_COMPONENTS_BY_DETAIL = {
  SS: 'Switch',
  A: 'Gauge',
  AC: 'Radio_CP001',
}

export default {
  ...DASH_META,
  ...META_BY_LOCATION_DETAIL,
  fallbacks: FALLBACK_COMPONENTS_BY_DETAIL,
  lists: {
    ICU: {
      id: 'ICU',
      label: 'A Panel: ICU',
      groups: {},
    },
    AUPNL: {
      id: 'AUPNL',
      label: 'B Panel: Right Hand Aux',
      groups: {
        au_gauges: {
          order: 0,
          id: 'au_gauges',
          panel: 'AUPNL',
          label: 'Aux Gauges',
          detail: ['A'],
        },
        au_other: {
          order: 1,
          id: 'au_other',
          panel: 'AUPNL',
          label: 'Aux Other',
          // WW2614 AU250: accept corrected A-A and existing AA layout data (PBI pending).
          detail: [
            'B',
            'D',
            'H',
            'J',
            'G',
            'S',
            'T',
            'U',
            'L',
            'AA',
            'A-A',
            'BB',
          ],
        },
      },
    },
    AGFAC: {
      id: 'AGFAC',
      label: 'B Panel: Right Hand',
      groups: {
        LSMST: {
          order: 0,
          id: 'LSMST',
          panel: 'AGFAC',
          label: 'Left MSF',
          isMsfOrMst: true,
          detail: ['SS'],
          staticPart: {
            label: strings.hazard_lights,
            afterIndex: 4,
          },
        },
        CSMAN: {
          order: 1,
          id: 'CSMAN',
          isMsfOrMst: true,
          panel: 'AGFAC',
          label: 'Center MSF',
          detail: ['SS'],
        },
        RSMAN: {
          order: 2,
          id: 'RSMAN',
          isMsfOrMst: true,
          panel: 'AGFAC',
          label: 'Right MSF',
          detail: ['SS'],
        },
        switches: {
          order: 3,
          id: 'switches',
          panel: 'AGFAC',
          label: 'Lower Switches',
          detail: ['F'],
        },
        gauges: {
          order: 4,
          id: 'gauges',
          panel: 'AGFAC',
          label: 'Gauges',
          detail: ['A'],
        },
        other: {
          order: 5,
          id: 'other',
          panel: 'AGFAC',
          label: 'Other',
          detail: ['C', 'B', 'E', 'DD', 'V', 'X', 'Y', 'S', 'L', 'EE', 'AC'],
        },
      },
    },
  },
}
